/** Lowercase, trim, and collapse internal whitespace so LLM variations still match. */
export function normalizeActionTitle(title: string): string {
    return title.trim().toLowerCase().replace(/\s+/g, " ");
}

type NextStepActionLike = {
    title: string;
    variant: "primary" | "secondary";
};

const CREATE_PR_ACTION_TITLE = "create pr";

/**
 * Only actions whose normalized title matches one of these are shown.
 * Everything else is silently dropped so the LLM can't produce noisy suggestions.
 */
export const ALLOWED_NEXT_STEP_TITLES = new Set([
    "create pr",
    "update agents.md",
    "create skill from this session",
    "build",
]);

export function isCreatePRAction(action: Pick<NextStepActionLike, "title">): boolean {
    return normalizeActionTitle(action.title) === CREATE_PR_ACTION_TITLE;
}

/**
 * Create PR should always use the promoted CTA treatment so the keyboard
 * shortcut and visual emphasis stay consistent even if the backend sends it
 * as secondary or omits an explicit primary action.
 */
export function getPrimaryNextStepAction<T extends NextStepActionLike>(actions: readonly T[]): T | undefined {
    return actions.find(isCreatePRAction) ?? actions.find((action) => action.variant === "primary");
}
